import config from '@/config'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { i18n } from '@/i18n'
import Vuelidate from 'vuelidate'
import VueGtm from '@gtm-support/vue2-gtm'
import VueScrollTo from 'vue-scrollto'
import VueCookies from 'vue-cookies'
import { SurveyBuilderPlugin } from '@frontend/survey-builder'
import * as Sentry from '@sentry/browser'

import { handleAppHeightChanges } from '@/helpers/utils'
import { ENV_DEV_OR_STAGING, VUE_APP_VERSION } from '@/helpers/environment'
import { setDeviceId } from '@/mixins/Experiments'
import Braze from '@/plugins/Braze'
import OpenTelemetry from '@/plugins/OpenTelemetry'
import SentryPlugin from '@/plugins/Sentry'

import { vueAnalyticPlugin } from '@frontend/simple-growth-frontend-tools'

import ABFeatureFlagMixin from '@/mixins/ABFeatureFlagMixin'
import FunnelTypeMixin from '@/mixins/FunnelTypeMixin'

Vue.config.productionTip = false
Vue.config.devtools = ENV_DEV_OR_STAGING

setDeviceId()

Vue.use(OpenTelemetry)

Vue.use(SentryPlugin)

Vue.use(Braze, {
	apiKey: config('BrazeApiKey'),
	baseUrl: config('BrazeSdkEndpoint'),
	store
})

Vue.use(Vuelidate)
Vue.use(VueScrollTo)
Vue.use(VueCookies)

Vue.use(VueGtm, {
	id: window.gtmContainerId,
	enabled: true,
	defer: true,
	debug: false,
	loadScript: true,
	vueRouter: router,
	ignoredViews: ['login_by_code']
})

Vue.use(SurveyBuilderPlugin)

Vue.config.errorHandler = function (error, vm, info) {
	Sentry.withScope((scope) => {
		scope.setExtras({ info })
		scope.setTags({
			vueError: true
		})
		Sentry.captureException(error)
	})

	setTimeout(() => {
		vm.$analytic.logEvent('Vue error', {
			message: error,
			info,
			location: window.location.href
		})
	}, 0)
}

/**
 * NOTE: This methods should be called BEFORE app instance initialising
 */
handleAppHeightChanges()

Vue.use(vueAnalyticPlugin, {
	options: {
		analyticsOptions: {
			apiKey: config('AmplitudePaltaWeb'),
			browserOptions: {
				serverUrl: 'https://telemetry.simple.paltabrain.com/v2/amplitude',
				appVersion: VUE_APP_VERSION,
				deviceId: window.deviceId,
				disableCookies: true
			},

			persistedProperties: {
				onboarding_version: VUE_APP_VERSION,
				// Свойство для статических экранов веб-воронки. Экраны из Strapi делают override свойства к 'strapi'
				type: 'static',
				funnel_type: 'main'
			},

			/**
			 * The error callback receives server responses with statuses < 200 and >= 300.
			 * @param {object} error - Original amplitude response object
			 * @param {number} error.code - The HTTP response status code of the request.
			 * @param {string} error.message - The response message
			 * @param {object} error.event - The final event object sent to Amplitude
			 */
			onError(error) {
				if (error.code === 0) return
				Sentry.withScope((scope) => {
					scope.setExtras({
						event: error.event
					})
					scope.setTags({
						analyticErrorCode: error.code,
						analyticErrorMessage: error.message
					})
					Sentry.captureMessage(error.message)
				})
			},
			logger: ENV_DEV_OR_STAGING
		},
		legacy: true,
		debug: false
	},
	router
})

Vue.mixin(ABFeatureFlagMixin)
Vue.mixin(FunnelTypeMixin)

// eslint-disable-next-line vue/require-name-property
new Vue({
	router,
	store,
	i18n,
	render: (h) => h(App)
}).$mount('#app')
